<template>
  <div class='tld-charge'>
    <!-- 顶部渐变背景 -->
    <div class='header-bg'></div>

    <!-- 充值手机号区域 -->
    <div class='phone-section'>
      <div class='phone-header'>
        <span class='label'>充值手机号</span>
        <span class='record-btn' @click='goRecord'>
          <img src='../../assets/img/telaidian/ic-record.png' class='record-icon' />
          充值记录
        </span>
      </div>
      <div class='phone-input-wrap'>
        <van-field
          v-model='phoneNumber'
          placeholder='请输入手机号'
          type='number'
          maxlength='11'
          @input='onPhoneInput'
          class='phone-input'
          :border='false'
        />
        <div class='last-use'>
          <span v-if='isHistoryNo'>上次使用</span>
          <img v-if='isHistoryNo||phoneNumber' src='../../assets/img/telaidian/ic-clear.png' class='clear-icon'
               @click='clearLastUse' />
        </div>
      </div>
    </div>

    <!-- 面值选择区域 -->
    <div class='amount-section'>
      <!-- Tab切换 -->
      <div class='tab-wrap'>
        <div
          :class="['tab-item', productType === '1' ? 'active' : '']"
          @click="switchTab('1')"
        >
          电费服务费通抵券
          <div class='tab-indicator' v-if="productType === '1'"></div>
        </div>
        <div
          :class="['tab-item', productType === '2' ? 'active' : '']"
          @click="switchTab('2')"
        >
          服务费抵用券
          <div class='tab-indicator' v-if="productType === '2'"></div>
        </div>
      </div>

      <!-- 面值宫格列表 -->
      <div class='amount-grid'>
        <div
          v-for='(item, index) in amountList'
          :key='index'
          :class="['grid-item', selectedIndex === index ? 'selected' : '']"
          @click='selectAmount(item, index)'
        >
          <div class='amount-value'><span class='yuan'>¥</span>{{ item.facePrice }}</div>
          <div class='amount-price'>售价{{ item.salePrice }}元</div>
        </div>
      </div>
    </div>

    <!-- 充值说明 -->
    <div class='description-section'>
      <div class='desc-content' v-html='description'></div>
    </div>

    <!-- 底部按钮 -->
    <div class='bottom-bar'>
      <van-button
        type='primary'
        :disabled='!canSubmit'
        :loading='submitLoading'
        loading-type='spinner'
        @click='handleSubmit'
        class='submit-btn'
      >
        ¥ {{ selectedAmount ? selectedAmount.salePrice : 0 }} 立即充值
      </van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { busiDescDetail, tldFacePriceList } from '@/api/telaidian'

export default {
  name: 'TldCharge',
  data() {
    return {
      phoneNumber: '',
      isHistoryNo: false,
      selectedIndex: -1,
      submitLoading: false,
      productType: '1', // 产品类型：1 电费服务费通抵券 / 2 服务费抵用券
      amountList: [], // 面值列表
      description: '', // 充值说明
      recordUrl: '' // 充值记录url
    }
  },
  computed: {
    // 当前选中的面值对象
    selectedAmount() {
      if (this.selectedIndex >= 0) {
        return this.amountList[this.selectedIndex]
      }
      return null
    },
    // 是否可以提交
    canSubmit() {
      return this.phoneNumber.length === 11 && this.selectedIndex >= 0
    }
  },
  created() {
    // 获取type参数，默认为1（电费服务费通抵券）
    this.productType = this.$route?.query?.type || '1'
    this.initData()
  },
  methods: {
    // 初始化数据
    async initData() {
      // 加载面值列表
      await this.loadFacePriceList()
      // 加载充值说明
      this.loadDescription()
    },
    // 加载面值列表（参考zhxIndex的历史账号逻辑）
    async loadFacePriceList() {
      try {
        const res = await tldFacePriceList({ type: this.productType })
        const payload = res && res.data ? res.data : {}

        this.recordUrl = payload.url || ''
        // 处理历史账号
        const account = payload.account || ''
        if (account) {
          this.phoneNumber = account
        }
        if (payload.isHistory === '0') {
          // 存在历史账号，显示"上次使用"
          this.isHistoryNo = true
        } else if (payload.isHistory === '1') {
          // 无历史账号
          this.isHistoryNo = false
        } else {
          this.isHistoryNo = false
        }

        // priceList -> amountList
        const list = Array.isArray(payload.priceList) ? payload.priceList : []
        this.amountList = list

        if (list.length > 0) {
          this.selectedIndex = 0
        }
      } catch (e) {
        Toast.fail('获取面值失败')
      }
    },
    // 加载充值说明
    async loadDescription() {
      try {
        const descType = this.productType === '1' ? 'tld_df' : 'tld_fw'
        const res = await busiDescDetail(descType)
        if (res && res.code === 200 && res.data && res.data.content) {
          const content = res.data.content
          const html = content.includes('_blank')
            ? content.replaceAll('_blank', '_self')
            : content
          this.description = html
        }
      } catch (e) {
        // ignore
      }
    },
    // 手机号输入
    onPhoneInput() {
      this.isHistoryNo = false
      // 限制只能输入数字
      this.phoneNumber = this.phoneNumber.replace(/\D/g, '')
    },
    // 清除上次使用
    clearLastUse() {
      this.phoneNumber = ''
      this.isHistoryNo = false
    },
    // 切换Tab
    async switchTab(type) {
      this.productType = type
      this.selectedIndex = -1 // 切换Tab时重置选中状态
      this.description = '' // 切换时置空充值说明
      // 切换时重新加载面值列表和充值说明
      await this.loadFacePriceList()
      this.loadDescription()
    },
    // 选择面值
    selectAmount(item, index) {
      if (!this.phoneNumber || this.phoneNumber.length !== 11) {
        Toast.fail('请先输入正确的手机号')
        return
      }
      this.selectedIndex = index
    },
    // 充值记录
    goRecord() {
      if (this.recordUrl) {
        window.location.href = this.recordUrl
      }
    },
    // 提交充值
    handleSubmit() {
      // 校验手机号格式
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(this.phoneNumber)) {
        Toast.fail('手机号码格式不正确')
        return
      }

      if (this.selectedIndex < 0) {
        Toast.fail('请选择充值面值')
        return
      }

      const selected = this.selectedAmount
      const tabName = this.productType === '1' ? '电费服务费通抵券' : '服务费抵用券'
      const productName = `${tabName} ${selected.facePrice}元`

      this.$router.push({
        name: 'TldOrderConfirm',
        query: {
          chargeAccount: this.phoneNumber,
          id: selected.id,
          productName,
          facePrice: selected.facePrice,
          salePrice: selected.salePrice,
          productType: this.productType
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.tld-charge {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 0.8rem;
  box-sizing: border-box;
  background-color: #f5f5f5;
  position: relative;

  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1.86rem;
    background: linear-gradient(180deg, #1966FF 0%, rgba(25, 102, 255, 0.75) 81.52%, rgba(25, 102, 255, 0) 100%);
    z-index: 0;
  }

  // 充值手机号区域
  .phone-section {
    position: relative;
    z-index: 1;
    padding: 0.2rem 0.2rem 0.27rem;

    .phone-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.15rem;

      .label {
        font-size: 0.13rem;
        color: white;
        font-weight: 500;
      }

      .record-btn {
        display: flex;
        align-items: center;
        font-size: 0.12rem;
        color: white;
        padding: 0.05rem 0.07rem;
        border: 0.005rem solid #FFFFFF;
        border-radius: 0.5rem;

        .record-icon {
          width: 0.16rem;
          height: 0.16rem;
          margin-right: 0.02rem;
        }

        span {
          margin-left: 0.04rem;
        }
      }
    }

    .phone-input-wrap {
      position: relative;

      .phone-input {
        background: transparent;
        border-bottom: 0.01rem solid rgba(245, 245, 245, 1);
        padding: 0.1rem 0;

        /deep/ .van-field__control {
          font-size: 0.27rem;
          color: white;
          font-weight: bold;

          &::placeholder {
            color: rgba(255, 255, 255, 0.5);
            font-size: 0.24rem;
            font-weight: 400;
          }
        }
      }

      .last-use {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        font-size: 0.13rem;
        color: white;

        .clear-icon {
          width: 0.12rem;
          height: 0.12rem;
          cursor: pointer;
        }

        span {
          margin-right: 0.04rem;
        }
      }
    }
  }

  // 面值选择区域
  .amount-section {
    position: relative;
    z-index: 1;
    margin: 0 0.15rem 0.15rem;
    //background: white;

    .tab-wrap {
      display: flex;
      justify-content: center;
      background: url('~@/assets/img/telaidian/bg-tab.png') no-repeat center / 100% 100%;
      border-radius: 0.12rem 0.12rem 0 0;
      height: 0.4rem;

      .tab-item {
        flex: none;
        width: 1.565rem;
        text-align: center;
        font-size: 0.13rem;
        color: #666666;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        // 第一个 tab（左侧）
        &:first-child {
          &.active {
            width: 1.885rem;
            background: url('~@/assets/img/telaidian/bg-selected-left.png') no-repeat center / 100% 100%;
            color: #333333;
            font-weight: 500;
            //border-radius: 0.1rem 0.1rem 0 0;
          }

          &:not(.active) {
            //border-radius: 0.1rem 0 0.1rem 0.1rem;
          }
        }

        // 第二个 tab（右侧）
        &:last-child {
          &.active {
            width: 1.885rem;
            background: url('~@/assets/img/telaidian/bg-selected-right.png') no-repeat center / 100% 100%;
            color: #333333;
            font-weight: 500;
            //border-radius: 0.1rem 0.1rem 0 0;
          }

          &:not(.active) {
            //border-radius: 0 0.1rem 0.1rem 0.1rem;
          }
        }

        .tab-indicator {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0.3rem;
          height: 0.04rem;
          background: #1966FF;
          border-radius: 0.02rem;
        }
      }
    }

    .amount-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.12rem;
      padding: 0.15rem 0.1rem;
      background: white;
      border-radius: 0 0 0.12rem 0.12rem;

      .grid-item {
        background: #F8F8F8;
        border-radius: 0.08rem;
        padding: 0.22rem 0 0.25rem;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
        border: 0.01rem solid #E9E9E9;

        &.selected {
          background: rgba(28, 129, 252, 0.05);
          border: 0.01rem solid #1C81FC;

          .amount-value {
            color: #1C81FC;
          }

          .amount-price {
            color: #1C81FC;
          }
        }

        .amount-value {
          font-size: 0.27rem;
          font-weight: bold;
          color: #111111;
          margin-bottom: 0.04rem;
          display: flex;
          align-items: baseline;
          justify-content: center;

          .yuan {
            font-size: 0.12rem;
            margin-right: 0.02rem;
          }
        }

        .amount-price {
          font-size: 0.12rem;
          color: #999999;
        }
      }
    }
  }

  // 充值说明
  .description-section {
    margin: 0 0.15rem;
    background: white;
    border-radius: 0.12rem;
    padding: 0.16rem 0.12rem;
    text-align: left;

    .desc-content {
      text-align: initial;
      line-height: initial;

      // 避免接口返回的富文本把布局撑爆
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }

      ::v-deep p {
        margin: 0 0 0.08rem 0;
      }

      ::v-deep a {
        color: #1E7DFF;
      }
    }
  }

  // 底部按钮
  .bottom-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    padding: 0.1rem 0.15rem calc(0.1rem + constant(safe-area-inset-bottom));
    padding: 0.1rem 0.15rem calc(0.1rem + env(safe-area-inset-bottom));
    background: white;

    .submit-btn {
      width: 100%;
      height: 0.5rem;
      border-radius: 0.5rem;
      font-size: 0.16rem;
      font-weight: 500;
      background-color: #4379F5;
      border: none;

      //&[disabled] {
      //  background: #c5d9ff;
      //  border-color: #c5d9ff;
      //}
    }
  }
}
</style>
